import React from 'react';
import { motion } from 'framer-motion';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-bg" />
      <div className="hero-content">
        <motion.div
          className="hero-text"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <h1 className="hero-heading">
            NIRUPRINT SOLUTIONS
            <span className="hero-heading-sub">Custom Cardboard Printing</span>
          </h1>
          <p className="hero-subheading">
            Elevate your brand with premium printing and binding services tailored to your needs.
          </p>
          <motion.a
            href="#quote"
            className="hero-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
          >
            Request a Quote
          </motion.a>
        </motion.div>
      </div>
      <div className="hero-contact">
        <p>
          UNIT H2C, Deseronto Estate, St. Mary Road, Slough, Berkshire, SL3 7EW |{' '}
          <a href="mailto:nirupal92@gmail.com">nirupal92@gmail.com</a> |{' '}
          <a href="tel:+447304083286">07304 083286</a>
        </p>
      </div>
    </section>
  );
};

export default HeroSection;